import {useQuery} from '@tanstack/react-query';
import {fetch} from '../services/UsageEventsService';

// FNP-536: single-record read for the detail view. Read-only — no create, update, or
// delete (the FNP-215 ingestion writer owns the lifecycle).
export const useUsageEvent = (id?: string) => {

    const usageEventQuery = useQuery({
        queryKey: ['usageEvent', id],
        queryFn: () => fetch(id!),
        enabled: !!id
    });

    return {
        record: usageEventQuery.data,
        loading: usageEventQuery.isLoading,
        // Surface error + fetched-but-empty so the detail page can show a "not found"
        // state instead of hanging on the loader forever when an id doesn't resolve. The
        // id is composite — `usage-event:<uuid>` — so a mis-encoded id would not resolve;
        // see the encodeURIComponent note in RecordsTable.
        isError: usageEventQuery.isError,
        notFound: usageEventQuery.isFetched && !usageEventQuery.data,
        fetchRecord: usageEventQuery.refetch,
    };
};
